module.exports = __webpack_public_path__ + "img/shot_bigtx112501.16c01c1e.png";